import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Generic drag-and-drop sorting with position tracking. Place on a container
// holding a `[data-sortable-target="sortable"]` element whose children carry a
// `.handle` and an `input[name$="[position]"]`. Reinitializes after cocoon inserts.
export default class extends Controller {
  static targets = ["sortable"]

  connect() {
    this.initSortable()
    // Cocoon emits via jQuery's .trigger(), which doesn't reach
    // addEventListener for colon-namespaced events — bind with jQuery.
    this.cocoonHandler = () => this.initSortable()
    jQuery(this.element).on('cocoon:after-insert', this.cocoonHandler)
  }

  disconnect() {
    jQuery(this.element).off('cocoon:after-insert', this.cocoonHandler)
    if (this.sortableInstance) {
      this.sortableInstance.destroy()
      this.sortableInstance = null
    }
  }

  initSortable() {
    const el = this.sortableTarget
    if (!el) return

    if (!this.sortableInstance) {
      this.sortableInstance = Sortable.create(el, {
        handle: '.handle',
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        filter: '.links',
        onEnd: () => this.updatePositions()
      })
    }
    this.updatePositions()
  }

  updatePositions() {
    this.sortableTarget.querySelectorAll('input[name$="[position]"]').forEach((input, i) => {
      input.value = i
    })
  }
}
